import React from 'react'
import {isMobile} from 'react-device-detect'
import styled from 'styled-components'

const Option = styled.span`
  &:hover {
    color: var(--bs-primary);
  }
`

const ProductTagsFilter = (props) => {
  const {
    machine,
    productTags,
    isOpen,
    setIsOpen
  } = props

  const [current, send] = machine

  const productTagFilter = current.context.filters.find(
    (filter) => filter.param === 'product_tag'
  )

  const productTagFilterValue = productTagFilter?.value

  const onProductTagFilter = (productTag) => {
    if (productTagFilterValue === productTag.value) {
      send({
        type: 'FILTER_REMOVE',
        param: 'product_tag'
      })
    } else {
      send({
        type: 'FILTER_SELECTION',
        filter: {
          param: 'product_tag',
          label: productTag.label,
          value: productTag.value
        }
      })
    }

    if (isMobile) {
      setIsOpen(!isOpen)
    }
  }

  return (
    <>
      {productTags.map((productTag) => {
        const isSelected = productTag.value === productTagFilterValue

        return (
          <div key={productTag.value} className="mb-1">
            <input
              type="radio"
              className="me-2"
              checked={isSelected}
              onChange={() => onProductTagFilter(productTag)}
              style={{cursor: 'pointer'}}
            />

            <label
              onClick={() => onProductTagFilter(productTag)}
              style={{cursor: 'pointer'}}
            >
              <Option className={isSelected ? 'fw-semibold' : 'fw-normal'}>
                {productTag.label}
              </Option>
            </label>
          </div>
        )
      })}
    </>
  )
}

export default ProductTagsFilter
